<template>
  <div 
    class="min-h-screen bg-white"
    :class="{ 'p-4 sm:p-6 lg:p-16 bg-gray-100': !isFullScreen }"
  >
    <DesktopSignature />
    <ThemeManager />
    
    <div v-if="authIsReady">
      <router-view v-slot="{ Component, route }">
        <transition name="fade" mode="out-in">
          <component :is="Component" :key="route.path" />
        </transition>
      </router-view>
    </div>

    <div v-else class="flex justify-center items-center h-screen">
      <p class="text-gray-500">Loading Application...</p>
    </div>
  </div>
</template>

<script>
import DesktopSignature from '@/components/DesktopSignature.vue';
import ThemeManager from '@/components/ThemeManager.vue';
import NotificationPopup from '@/components/NotificationPopup.vue';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    DesktopSignature,
    ThemeManager,
    NotificationPopup,
  },
  data() {
    return {
      notificationInterval: null,
      notificationToShow: null,
      shownNotifications: new Set(),
    }
  },
  computed: {
    ...mapState(['authIsReady', 'upcomingRecordings', 'user']),
    isFullScreen() {
      return this.$route.meta.fullScreen || false;
    }
  },
  methods: {
    ...mapActions(['initializeAuth']),
    startNotificationWatcher() {
      if (this.notificationInterval) clearInterval(this.notificationInterval);
      this.notificationInterval = setInterval(() => {
        const now = new Date();
        const oneHourFromNow = new Date(now.getTime() + 60 * 60 * 1000);
        for (const recording of this.upcomingRecordings) {
          if (!recording.recordingDate?.toDate) continue;
          const recordingTime = recording.recordingDate.toDate();
          if (recordingTime <= oneHourFromNow && recordingTime > now && !this.shownNotifications.has(recording.id)) {
            this.notificationToShow = recording;
            this.shownNotifications.add(recording.id);
            break;
          }
        }
      }, 10000);
    },
    stopNotificationWatcher() {
      if (this.notificationInterval) {
        clearInterval(this.notificationInterval);
      }
    },
    dismissNotification() {
      this.notificationToShow = null;
    }
  },
  watch: {
    authIsReady(isReady) {
      if (isReady) {
        this.startNotificationWatcher();
      } else {
        this.stopNotificationWatcher();
        this.shownNotifications.clear();
      }
    }
  },
  // --- START: THE DEFINITIVE, FINAL FIX ---
  async created() {
    await this.initializeAuth();
  },
  // --- END: THE DEFINITIVE, FINAL FIX ---
  beforeUnmount() {
    this.stopNotificationWatcher();
  }
}
</script>

<style>
@import '@/assets/tailwind.css';
.fade-enter-active, .fade-leave-active { transition: opacity 0.25s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>